export default {
    name: "video-modal",
    props: {
        link: {
            type: String,
            default: () => null,
        },
    }
}